module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Related services","slug_prefix":"services"},"nl":{"title":"Gerelateerde services","slug_prefix":"diensten"}}')
  delete Component.options._Ctor
}
